import { fluidRange } from 'polished';
import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx } from 'react/jsx-runtime';

const Eyebrow = props => {
  const {
    children,
    className,
    testID
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(StyledP, {
      className: `${className} ho-paragraph`,
      "data-testid": testID,
      children: children
    })
  });
};
const StyledP = styled.p`
  ${_ref => {
  let {
    theme
  } = _ref;
  return fluidRange({
    prop: 'font-size',
    fromSize: `${theme.fontStyles.eyebrow.fontSizeMin}px`,
    toSize: `${theme.fontStyles.eyebrow.fontSizeMax}px`
  }, `${theme.screen.xxs}`, `${theme.screen.xl}`);
}}
  color: inherit;
  font-family: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fontStyles.eyebrow.fontFamily;
}};
  font-weight: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fontStyles.eyebrow.fontWeight;
}};
  letter-spacing: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return `${theme.fontStyles.eyebrow.letterSpacing}em`;
}};
  line-height: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.fontStyles.eyebrow.lineHeight;
}};
  text-transform: uppercase;
`;
Eyebrow.defaultProps = {
  children: null,
  className: '',
  testID: 'eyebrow'
};
Eyebrow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  testID: PropTypes.string
};
var Eyebrow$1 = Eyebrow;

export { Eyebrow$1 as default };
//# sourceMappingURL=Eyebrow.js.map
